// AUTHOR: GOPALAKRISHNAN
// VERSION: 0.0.1
// LAST EDIT: GOPALAKRISHNAN
// DATE: 05/01/2026
// DESCRIPTION: DEALER REPORT PAGE SERVICES
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';
/************* FETCH DEALER REPORT LIST START ******************* */
export const fetchDealerReport = (fetchData: any) => {
	const data = {
		DealerReportToken: fetchData,
	};
	const url = `${API_URL}getDealerReport`;
	return makeApiCall(url, data);
};
/************* FETCH DEALER REPORT LIST END ******************* */
